<template>
  <div id="app">
    <google-map z-index='0'/>
    <audio-player z-index='1'/>
    <map-zoom-control z-index='1'/>
  </div>
</template>

<script>
import GoogleMap from "./components/GoogleMap";
import AudioPlayer from "./components/AudioPlayer";
import MapZoomControl from "./components/MapZoomControl";
import { EventBus } from '@/eventBus.js';

let mouseDown = 0;
document.body.onmousedown = function() {
  ++mouseDown;
  EventBus.$emit('mouseDown', mouseDown);
};

document.body.onmouseup = function() {
  --mouseDown;
  EventBus.$emit('mouseDown', mouseDown);
}

export default {
  name: "App",
  components: {
    GoogleMap, AudioPlayer, MapZoomControl
  }
};
</script>
